module.exports = __webpack_public_path__ + "static/img/yinxu_print.png";